import React from 'react';
import PropTypes from 'prop-types';
import { Card, PolycardContext } from '@polycard/card';

import { useRenderContext } from '../../pages/home/context';
import { FORMATS_SEPARATOR } from '../polycardCarousel/utils';
import { WITH_POLYCARD_GALLERY } from '../../utils/constants/shop/types';

const withPolycardGallery = (Component) => {
  const PolycardGallery = props => {
    const { shopType, device, siteId, appearance } = useRenderContext();
    const { tracking_id: trackingId = '' } = appearance?.appearance?.properties?.metrics || {};

    const trackUrl = (url) => {
      if (!url) return url;
      const encodedPlaceholder = '%7Btracking_id%7D';
      const encodedTrackingId = encodeURIComponent(trackingId);
      return trackingId && url
        ? url.replace(encodedPlaceholder, encodedTrackingId)
        : url;
    };

    const updateProps = {
      ...props,
      view_more_action: {
        ...props?.view_more_action,
        target: trackUrl(props?.view_more_action?.target || ''),
      },
    };

    const { categories } = updateProps;
    const { polycard_context: polycardContext, polycards } = categories?.[0] || {};

    const formats = {
      thousandSeparator: FORMATS_SEPARATOR.thousand[siteId] || FORMATS_SEPARATOR.thousand.default,
      decimalSeparator: FORMATS_SEPARATOR.decimal[siteId] || FORMATS_SEPARATOR.decimal.default,
    };

    const isPolycard = polycardContext && polycards?.length > 0;

    const withPolycard = WITH_POLYCARD_GALLERY.includes(shopType) && isPolycard;

    if (!withPolycard) {
      return <Component {...updateProps} />;
    }

    const addTrackItem = (item) => {
      const urlFragmentsWithTrack = trackUrl(item.metadata.url_fragments);
      return {
        ...item,
        metadata: {
          ...item.metadata,
          url_fragments: urlFragmentsWithTrack,
        },
      };
    };

    const PolycardItem = propsPolycard => (
      <li>
        <Card polycard={addTrackItem(propsPolycard?.polycard)} />
      </li>
    );

    return (
      <PolycardContext
        contextValue={
          {
            ...polycardContext,
            type: 'grid-card',
            target: '_self',
          }
        }
        deviceType={device}
        withoutIcons
        {...formats}
      >
        <Component
          ComponentCard={PolycardItem}
          isPolycard={withPolycard}
          key={`gallery-polycard-${updateProps?.id}`}
          {...updateProps}
        />
      </PolycardContext>
    );
  };

  PolycardGallery.propTypes = {
    view_more_action: PropTypes.string,
    categories: PropTypes.arrayOf(PropTypes.shape({})),
  };
  return PolycardGallery;
};

export default withPolycardGallery;
